import { isVoid } from "@/shared/utils";
import type { NotesTableItem } from "@/features/NotesManager/model";
import type { Note, Person } from "@/services/api";

export const createNotesTableData = (notes: Note[], persons: Person[]): NotesTableItem[] => {
  const personByIdMap = new Map(persons.map((person) => [person.id, person]));

  return notes.map((note) => {
    const person = personByIdMap.get(note.personId);

    if (isVoid(person)) {
      return { ...note, person: null };
    }

    return {
      ...note,
      person,
    };
  });
};
